import {SaveManager, Storage} from "html-living-framework/lib/Save/SaveManager";
import {StorageModel, Version} from "./StorageModel";

export class GameStorage {

    private static readonly saveManager = new SaveManager();

    public static get model(): StorageModel {
        const modelString = this.saveManager.readString("luna-packages-model", undefined, Storage.Local);
        if (modelString) {
            try {
                const model = JSON.parse(modelString) as StorageModel;
                if (model.version === Version) {
                    return model;
                }
            } catch (e) {
                // ignore
            }
        }
        return {version: Version};
    }

    public static set model(value: StorageModel) {
        this.saveManager.storeString("luna-packages-model", JSON.stringify(value), Storage.Local);
    }
}
